import React from 'react';
import { useParams } from 'react-router-dom';
import DealType from '../../../../enums/deal-type';
import EditProduced from './produced/edit-produced';
import EditPurchased from './purchased/edit-purchased';
import EditSold from './sold/edit-sold';
import EditSpent from './spent/edit-spent';
import EditLost from './lost/edit-lost';
import EditRecycled from './recycled/edit-recycled';
import EditSelfConsumed from './self-consumed/edit-self-consumed';
import EditMoved from './moved/edit-moved';

export default function Edit() {
  const { dealType } = useParams<{ dealType: DealType }>();

  switch (dealType) {
    case DealType.produced:
      return <EditProduced />;
    case DealType.purchased:
      return <EditPurchased />;
    case DealType.sold:
      return <EditSold />;
    case DealType.spent:
      return <EditSpent />;
    case DealType.lost:
      return <EditLost />;
    case DealType.recycled:
      return <EditRecycled />;
    case DealType.self_consumed:
      return <EditSelfConsumed />;
    case DealType.moved:
      return <EditMoved />;
  }
}
